/* eslint-disable no-undef */
import axios from 'axios';
import { configureHttpHeaders, onSuccess, onError, onErrorUnmatched } from './apiHelpers';
import { getCaseDataBaseUrl } from './caseDataBaseUrl.js';
import { getCaseData2BaseUrl } from './caseData2BaseUrl.js';
import { VITE_CASE_DATA_API, VITE_CASE_DATA2_API, VITE_IMAGE_MATCHER_API, VITE_IMAGE_READER_API } from 'Constants/appEnvConstants'

const __WEX_QUEUEID__ = 80;
const __AMEX_QUEUEID__ = 71;
const __TRANS_UNMATCH_QUEUE_ID__ = 6;
const __UNMATCH_MERCHANT_IMG__ = 15;
const __UNMATCH_SCHEME_IMG__ = 9;
const __ACTIVE_STAGE__ = 81;

export const urlRelativeMapping = {
  15: 'api/v1/disputecasedata/case/documents/unmatched?queueId=',
  9: 'api/v1/disputecasedata/case/documents/unmatched?queueId=',
  36: 'api/v1/disputecasedata/queue/36/case?',
  6: 'api/v1/disputecasedata/case/unmatched/transactions',
  81: 'api/v1/disputecasedata/cases/activestage/casedetails',
  8: 'api/v1/disputecasedata/case/queues?queueId=',
  71: 'api/v1/disputecasedata/amex/exception/cases',
  80: 'api/v1/disputecasedata/wex/exception/cases',
  case_type: 'api/v1/disputecasedata/dispute/stages',
  case_stage: 'api/v1/disputecasedata/dispute/stages',
  hpy_petro_name: 'api/v1/disputecasedata/hpy/petropay',
  petropay_name: 'api/v1/disputecasedata/hpy/petropay',
  card_brand: 'api/v1/disputecasedata/cardbrands',
  case_status: 'api/v1/disputecasedata/dispute/status',
  trans_case_stage: 'api/v1/disputecasedata/dispute/stages',
  reason_code: 'api/v1/disputecasedata/reasoncodes',
  disposition: 'api/v1/disputecasedata/disposition',
  action_code: 'api/v1/disputecasedata/actioncode',
  corpregion: 'api/v1/disputecasedata/corpregion',
  card_type: 'api/v1/disputecasedata/cardbrands',
  status: 'api/v1/disputecasedata/dispute/status',
  card_brand_code: 'api/v1/disputecasedata/cardbrands',
  merchantRegionCode: 'api/v1/disputecasedata/regions',
  lateststageind: 'api/v1/disputecasedata/lateststageind',
  merchant_case_status: 'api/v1/disputecasedata/merchantstatus',
  merchant_dspn_actn: 'api/v1/disputecasedata/merchantdisposition',
  merchant_adjustment: 'api/v1/disputecasedata/dispute/adjustment',
  case_card_brand: 'api/v1/disputecasedata/cardbrands',

  // createQueue
  cq_action_code: 'api/v1/disputecasedata/actioncode',
  cq_activity_code: 'api/v1/disputecasedata/disposition',
  cq_card_brand: 'api/v1/disputecasedata/cardbrands',
  cq_case_status: 'api/v1/disputecasedata/dispute/status',
  cq_case_type: 'api/v1/disputecasedata/dispute/stages',
  cq_dispute_currency: 'api/v1/disputecasedata/currency/details',
  cq_reason_code: 'api/v1/disputecasedata/reasoncodes',
  cq_trnsctn_currency: 'api/v1/disputecasedata/currency/details',
  cq_sttlmnt_crrncy: 'api/v1/disputecasedata/currency/details',
  cq_ex_corp_region: 'api/v1/disputecasedata/corpregion',
  cq_participantId: 'api/v1/disputecasedata/binConfigDetails',
  cq_ex_participantId: 'api/v1/disputecasedata/binConfigDetails',

  // Productivity Report
  pr_card_brand: 'api/v1/disputecasedata/cardbrands',
  pr_case_stage: 'api/v1/disputecasedata/dispute/stages',
  pr_region: 'api/v1/disputecasedata/regions',

  // Unresolved RTI
  un_card_brand: 'api/v1/disputecasedata/cardbrands',
  un_case_stage: 'api/v1/disputecasedata/dispute/stages',

  //Product Reports
  idr_action_code: 'api/v1/disputecasedata/actioncode',
  idr_disposition: 'api/v1/disputecasedata/disposition',
  idr_case_type: 'api/v1/disputecasedata/incomingdisputestages',

  // Dispute Inventory and BER Reports
  portfolio: 'api/v1/disputecasedata/regions',

  // file import under admin menu
  fileImport: 'api/v1/disputecasedata/regions',
};

const PROPERTY_ORDER = {
  15: 'propertyDirections',
  9: 'propertyDirections',
  36: 'propertyDirections',
  6: 'direction',
  8: 'direction',
  71: 'direction',
  80: 'direction',
  81: 'direction',
};

const UNMATCHED_TRANS_FIELD_MAPPING = {
  trans_arn: 'acquirerReferenceNumber',
  firstSixMasked: 'firstSixMasked',
  lastFourMasked: 'lastFourMasked',
  trans_from_dispt_amt: 'baseAmount',
  trans_to_dispt_amt: 'endAmount',
  trans_from_date: 'startDate',
  trans_to_date: 'endDate',
  trans_reason_code: 'reasonCode',
  trans_case_stage: 'caseStage',
  trans_account_number: 'globalToken',
  prod_sla_date_from: 'prodSlaStartDate',
  prod_sla_date_to: 'prodSlaEndDate',
  prod_sla_count_from: 'prodSlaBaseCounter',
  prod_sla_count_to: 'prodSlaEndCounter',
  action_code: 'disptnActionDescrition',
  disposition: 'disptnActivityDescription',
  disposition_desc: 'disposition',
};

let CASE_DATA_API = getCaseDataBaseUrl();
let CASE_DATA2_API = getCaseData2BaseUrl();

export function getAllUnmatchedCases(
  queueId,
  pageNumber,
  size,
  sort,
  appliedFilters,
  regionCode,
  acquirerList,
  caseNumber,
  caseStageId,
) {
  queueId = Number(queueId);
  let isFilterAvailable = false;
  const orderBy = sort.key;
  const direction = sort.order ? 'ASC' : 'DESC';
  const sortObj = sort.map((obj) => {
    return {
      fieldId: obj.key,
      orderByProperty: obj.order ? 'ASC' : 'DESC',
    };
  });
  let sortKeyString = '';
  let sortOrderString = '';

  sortObj.forEach((element) => {
    sortKeyString += `orderByProperties=${element.fieldId}&`;
    sortOrderString += `propertyDirections=${element.orderByProperty}&`;
  });

  configureHttpHeaders(axios);
  let url = '';
  if (appliedFilters === undefined || appliedFilters.length === 0) {
    let sortStr = { sortingElement: sortObj };
    url = `${urlRelativeMapping[queueId]}${
      queueId === __TRANS_UNMATCH_QUEUE_ID__ || queueId === __AMEX_QUEUEID__ || queueId === __ACTIVE_STAGE__
        ? '?'
        : queueId + '&'
    }pageNumber=${pageNumber}&size=${size}&sortingElementValue=${encodeURI(JSON.stringify(sortStr))}`;
    // return get(CASE_DATA_API, `${urlRelativeMapping[queueId]}${queueId}&pageNumber=${pageNumber}&size=${size}&orderByProperties=${orderBy}&${PROPERTY_ORDER[queueId]}=${direction}`);
    if (queueId === __AMEX_QUEUEID__ || queueId === __WEX_QUEUEID__) {
      url = `${urlRelativeMapping[queueId]}?pageNumber=${pageNumber}&size=${size}&${sortKeyString}${sortOrderString}`;
    }

    if (queueId === __TRANS_UNMATCH_QUEUE_ID__) {
      let sortStr = { sortingElement: sortObj };
      url = `${
        urlRelativeMapping[queueId]
      }?pageNumber=${pageNumber}&size=${size}&isFilterAvailable=${isFilterAvailable}&sortingElementValue=${encodeURI(
        JSON.stringify(sortStr),
      )}`;
    }
    if (queueId === __ACTIVE_STAGE__) {
      let sortStr = { sortingElement: sortObj };
      url = `${
        urlRelativeMapping[queueId]
      }?pageNumber=${pageNumber}&size=${size}&isFilterAvailable=${isFilterAvailable}&sortingElementValue=${encodeURI(
        JSON.stringify(sortStr),
      )}`;
    }
    if (queueId === __UNMATCH_MERCHANT_IMG__ || queueId === __UNMATCH_SCHEME_IMG__) {
      url = `${urlRelativeMapping[queueId]}${queueId}&pageNumber=${pageNumber}&size=${size}&${sortKeyString}${sortOrderString}`;
    }
  } else {
    let filterString = '';
    let sortStr = { sortingElement: sortObj };

    appliedFilters.forEach((element) => {
      filterString += `${UNMATCHED_TRANS_FIELD_MAPPING[element.elementId]}=${element.elementValue}&`;
    });
    if (queueId === __TRANS_UNMATCH_QUEUE_ID__ || queueId === __ACTIVE_STAGE__) {
      let orderByProperties = '';
      let sortDirection = '';
      isFilterAvailable = true;

      sort.forEach((sortElement, sortElementIndex) => {
        // API is ubnable to handle multiple sort values, Need to remove this condition once APIs are capable of handling it.
        if (sortElementIndex === 0) {
          orderByProperties = `${orderByProperties}${sortElementIndex === 0 ? '' : ','}${sortElement.key}`;
          sortDirection = `${sortDirection}${sortElementIndex === 0 ? '' : ','}${
            sortElement.order === 1 ? 'ASC' : 'DESC'
          }`;
        }
      });

      url = `${
        urlRelativeMapping[queueId]
      }?pageNumber=${pageNumber}&size=${size}&isFilterAvailable=${isFilterAvailable}&${filterString}&sortingElementValue=${encodeURI(
        JSON.stringify(sortStr),
      )}`;
    } else if (queueId === __AMEX_QUEUEID__) {
      url = `api/v1/disputecasedata/amex/cases?pageNumber=${pageNumber}&size=${size}&orderByProperties=${orderBy}&${PROPERTY_ORDER[queueId]}=${direction}&${filterString}`;
    } else if (queueId === __WEX_QUEUEID__) {
      url = `api/v1/disputecasedata/wex/cases?pageNumber=${pageNumber}&size=${size}&orderByProperties=${orderBy}&${PROPERTY_ORDER[queueId]}=${direction}&${filterString}`;
    }
    if (queueId === __UNMATCH_MERCHANT_IMG__ || queueId === __UNMATCH_SCHEME_IMG__) {
      url = `${urlRelativeMapping[queueId]}${queueId}&pageNumber=${pageNumber}&size=${size}&${sortKeyString}${sortOrderString}${PROPERTY_ORDER[queueId]}=${direction}&${filterString}`;
    }
    // return get(CASE_DATA_API, `api/v1/disputecasedata/case/transfailed?pageNumber=${pageNumber}&size=${size}&orderByProperties=${orderBy}&${PROPERTY_ORDER[queueId]}=${direction}&${filterString}`);
  }
  if (regionCode !== undefined && regionCode !== null && regionCode !== '') {
    url = `${url}&regionCode=${regionCode}`;
  }
  if (caseNumber && caseStageId) {
    url += `&caseNumber=${caseNumber}&caseStageId=${caseStageId}`;
  }

  if (acquirerList !== undefined && acquirerList !== null && acquirerList !== '') {
    url = `${url}&acquirerList=${acquirerList}`;
  }
  return get(CASE_DATA_API, `${url}`);
}

export function getMerchantImageData(documentName) {
  configureHttpHeaders(axios);
  return get(VITE_IMAGE_READER_API, `api/v1/imagereader/image/${documentName}`);
}

export function getSchemeImageData(documentId) {
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, `api/v1/disputecasedata/case/id/${documentId}/document`);
}

export function getImageContent(documentDirectoryPath, documentName) {
  configureHttpHeaders(axios);
  return get(
    VITE_IMAGE_READER_API,
    `api/v1/imagereader/image?documentName=${documentName}&fileDirPath=${documentDirectoryPath}`,
  );
}

export function getQueueRecordCount() {
  const Url = 'api/v1/disputecasedata/queue/recordcount';
  configureHttpHeaders(axios);
  return getBase(`${CASE_DATA2_API}${Url}`);
}

export function postFilterImageValues(resultString) {
  const Url = 'api/v1/disputecasedata/cases?';
  configureHttpHeaders(axios);
  return get(`${CASE_DATA_API}${Url}`, resultString);
}

export function attachImage(caseStageId, caseNumber, documentId, selectedPages) {
  const Url = 'api/v1/linker/document/';
  configureHttpHeaders(axios);
  return post(`${VITE_IMAGE_MATCHER_API}${Url}${documentId}/case/${caseNumber}/stage/${caseStageId}`, selectedPages);
}
export function attachAndArchiveImage(documentId, imageDataArray) {
  const Url = 'api/v1/linker/document/';
  configureHttpHeaders(axios);
  return postUnmatched(`${VITE_IMAGE_MATCHER_API}${Url}${documentId}`, imageDataArray);
}

export function fetchLevelOneQuestionnaireComponents(reasonCode) {
  const url = `api/v1/disputecasedata/questionnaire/visa/component/levelone?reasonCode=${reasonCode}`;
  return get(CASE_DATA2_API, url);
}
export function fetchLevelTwoQuestionnaireComponents(reasonCode, disputeType) {
  const url = `api/v1/disputecasedata/questionnaire/visa/component/leveltwo?caseResponseCode=${reasonCode}&disputeType=${disputeType}`;
  return get(CASE_DATA2_API, url);
}

export function fetchLevelThreeQuestionnaireComponents() {
  const url = 'api/v1/disputecasedata/questionnaire/visa/component/levelthree';
  return get(CASE_DATA2_API, url);
}

export function undoAttachImage(documentId) {
  const Url = `api/v1/linker/document/${documentId}`;
  configureHttpHeaders(axios);
  return axios.put(`${VITE_IMAGE_MATCHER_API}${Url}`);
}
export function attachTransactionCase(transactionDetail, caseNumber) {
  const Url = 'api/v1/disputecasedata/case/reference/transaction';
  const attachResponse = {
    caseNumber: parseInt(caseNumber, 10),
    transactionDetail,
  };
  configureHttpHeaders(axios);
  return post(`${CASE_DATA2_API}${Url}`, attachResponse);
}

export function getPredefinedMessage(languageIndCode, caseStageId) {
  configureHttpHeaders(axios);
  return get(
    CASE_DATA2_API,
    `api/v1/disputecasedata/merchant/message/language/${languageIndCode}/stage/${caseStageId}`,
  );
}

export function getFilterValuesBasedOnElementIdWithAcquirer(elementId, acquirerAccessList) {
  configureHttpHeaders(axios);
  return elementId === 'reason_code' || elementId === 'cq_reason_code'
    ? get(CASE_DATA2_API, urlRelativeMapping[elementId] + `?acquirerAccessList=${acquirerAccessList}`)
    : get(CASE_DATA_API, urlRelativeMapping[elementId] + `?acquirerAccessList=${acquirerAccessList}`);
}


export const fetchParticipantDetails = (elementId, acquirerCode) => {
 configureHttpHeaders(axios);
  return elementId === 'cq_participantId' || elementId === 'cq_ex_participantId'
    ? get(CASE_DATA_API, urlRelativeMapping[elementId] + `?acquirer=${acquirerCode}`)
    : get(CASE_DATA_API, urlRelativeMapping[elementId] + `?acquirer=${acquirerCode}`);
};



export function getFilterValuesBasedOnElementId(elementId) {
  configureHttpHeaders(axios);
  return elementId === 'reason_code' || elementId === 'cq_reason_code'
    ? get(CASE_DATA2_API, urlRelativeMapping[elementId])
    : get(CASE_DATA_API, urlRelativeMapping[elementId]);
}

export function getLetterTemplates(languageIndCode, acquirerCode, actionViewCode, cardBrandCode, disputeStageId) {
  configureHttpHeaders(axios);
  return get(
    CASE_DATA2_API,
    `api/v1/disputecasedata/letter/${languageIndCode}?acquirerCode=${acquirerCode}&actionViewCode=${actionViewCode}&cardBrandCode=${cardBrandCode}&disputeStageId=${disputeStageId}`,
  );
}

export function fetchLedgers(acquirerCode, merchantRegionCode) {
  configureHttpHeaders(axios);
  return get(
    CASE_DATA_API,
    `api/v1/disputecasedata/ledgers?acquirerCode=${acquirerCode}&merchantRegionCode=${merchantRegionCode}`,
  );
}

export function getDataAccordingToGlobalSearchFilters(
  searchkey,
  searchType,
  pageNumber,
  size,
  sort,
  acquirerAccessList,
) {
  let param;
  const sortObj = sort.map((obj) => {
    return {
      fieldId: obj.key,
      orderByProperty: obj.order ? 'ASC' : 'DESC',
    };
  });
  if (searchType === 'caseNumber') {
    param = `globalToken=0&caseNumber=${searchkey}&merchantNumber=0`;
  } else if (searchType === 'merchantNumber') {
    param = `globalToken=0&caseNumber=0&merchantNumber=${searchkey}`;
  } else if (searchType === 'accountNumber') {
    param = `globalToken=${searchkey}&caseNumber=0&merchantNumber=0`;
  } else if (searchType === 'arn') {
    param = `globalToken=0&caseNumber=0&merchantNumber=0&arn=${searchkey}`;
  } else {
    param = `globalToken=${searchkey}&caseNumber=${searchkey}&merchantNumber=${searchkey}&arn=${searchkey}&cardNumber=${searchkey}`;
  }
  let sortStr = { sortingElement: sortObj };
  const Url = `api/v1/disputecasedata/quick/cases?${param}&page=${pageNumber}&size=${size}&acquirerAccessCode=${acquirerAccessList}&sortingElementValue=${encodeURI(
    JSON.stringify(sortStr),
  )}`;
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, Url);
}

export function postArchiveImage(resultString) {
  const Url = 'api/v1/match/image/archive';
  configureHttpHeaders(axios);
  return put(`${VITE_IMAGE_MATCHER_API}${Url}`, resultString);
}
// get action description list
export function getActionDescriptions(url, searchInputDetails) {
  configureHttpHeaders(axios);
  return getDataWithPathVariable(url, searchInputDetails);
}
export function getResponseReasonCodeDescriptions(url) {
  configureHttpHeaders(axios);
  return url.includes('violations') ? get(CASE_DATA2_API, url) : get(CASE_DATA_API, url);
  //return get(CASE_DATA_API, url);
}

export function getRIDResponseReasonCodeDescription(url) {
  configureHttpHeaders(axios);
  return get(CASE_DATA2_API, url);
}

function getDataWithPathVariable(url, searchInputDetails) {
  let pathVariables = '';
  let separator = '';
  // eslint-disable-next-line no-restricted-syntax, no-unused-vars
  for (const key in searchInputDetails) {
    pathVariables = `${pathVariables + separator + key}=${searchInputDetails[key]}`;
    separator = '&';
  }
  return axios.get(`${CASE_DATA_API}${url}?${pathVariables}`).then(onSuccess).catch(onError);
}

export function getDataColumns(pageId) {
  configureHttpHeaders(axios);
  // return get(VITE_MOCK_API, `api/v1/disputecasedata/user/columns/${pageId}?userId=System`);
  return get(CASE_DATA_API, `api/v1/disputecasedata/user/columns/${pageId}?userId=System`);
}

export function getAllRegion(elementId, fetchOnlyDefaultQueueRegions) {
  configureHttpHeaders(axios);
  return get(
    CASE_DATA_API,
    urlRelativeMapping[elementId] + `?fetchOnlyDefaultQueueRegions=${fetchOnlyDefaultQueueRegions}`,
  );
}

export function getDataColumnsCustomQueue(pageId, customQueueId) {
  configureHttpHeaders(axios);
  let url = `api/v1/disputecasedata/user/columns/${pageId}?userId=System`;
  if (customQueueId) {
    url = url + `&customQueueId=${customQueueId}`;
  }
  return get(CASE_DATA_API, url);
}

export function getRegionList(acquirerAccess) {
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, `api/v1/disputecasedata/getdefaultQueues?acquirerAccess=${acquirerAccess}`);
  //return get(`https://apis-dev.globalpay.com/mdims/case-data/api/v1/disputecasedata/getdefaultQueues`, acquirerAccess);
}

export function undoAttachTransaction(caseNumber, transactionId) {
  configureHttpHeaders(axios);
  return deleteUrl(CASE_DATA2_API, `api/v1/disputecasedata/case/reference/transaction/${transactionId}/${caseNumber}`);
}

export function postActiveFilters(pageId, columns, customQueueId) {
  const data = {
    columns,
    userName: 'SYSTEM',
  };
  let Url = `api/v1/disputecasedata/user/columns/${pageId}`;
  if (customQueueId) {
    Url = Url + `?customQueueId=${customQueueId}`;
  }
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API + Url}`, data);
}

/**
 * Get transfer Purpose List
 */
export function getTransferPurposeList() {
  configureHttpHeaders(axios);
  return get(CASE_DATA2_API, 'api/v1/disputecasedata/transfer/purposes');
}
/**
 * Get transfer to List
 */
export function getTransferToList() {
  configureHttpHeaders(axios);
  return get(CASE_DATA2_API, 'api/v1/disputecasedata/fetch/users');
}

/**
 * Post transfer case details
 */
export function transferCase(transferDetail) {
  const Url = `api/v1/disputecasedata/transfer/assign`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA2_API + Url}`, transferDetail);
}

/*
  Post - Lock Case
*/
export function postLockCase(caseNumber, caseStageId) {
  const Url = `api/v1/disputecasedata/case/${caseNumber}/${caseStageId}/lock`;
  configureHttpHeaders(axios);
  return postUnmatched(`${CASE_DATA_API + Url}`);
}
/*
  Delete - Unlock Case
*/
export function unlockCase(caseNumber, caseStageId) {
  configureHttpHeaders(axios);
  let url = `api/v1/disputecasedata/case/unlock`;
  if (caseNumber) {
    url += `?caseNumber=${caseNumber}`;
    if (caseStageId) {
      url += `&caseStageId=${caseStageId}`;
    }
  }
  return deleteUrl(CASE_DATA_API, url);
}

/*
  Post - Unlock All Cases
*/
export function unlockAllCases(caseNumbers) {
  let url = `api/v1/disputecasedata/case/unlock`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API + url}`, caseNumbers);
}

export function updateTimeForLockedCases(lockedCases) {
  configureHttpHeaders(axios);
  const url = 'api/v1/disputecasedata/cases/lock';
  let data = {
    recentLockedCases: lockedCases,
  };
  return post(`${CASE_DATA_API + url}`, data);
}

/*
  Check is case Locked
*/
export function checkIfLocked(caseNumber, caseStageId) {
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, `api/v1/disputecasedata/case/${caseNumber}/${caseStageId}`);
}

/*
  Export all records
 */

export function exportUnmatchedQueue(data) {
  const url = `api/v1/export/unmatched/transaction/`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API}${url}`, data);
}
export function exportDataSearchQueue(data, type) {
  const url = `api/v1/export/datasearch/${type}`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API}${url}`, data);
}
export function exportMerchantQueueData(data) {
  const url = `api/v1/export/unmatchedmerchant`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API}${url}`, data);
}
export function exportActiveStageQueue(data) {
  const url = `api/v1/export/activate/stage`;
  configureHttpHeaders(axios);
  return post(`${EXPORT_API}${url}`, data);
}
export function exportAmexQueueData(data) {
  const url = `api/v1/export/amex`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API}${url}`, data);
}
export function exportImageQueueData(data) {
  const url = `api/v1/export/imagedata`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API}${url}`, data);
}
/**GlobalSearch Endpoints */
export function exportQuickSearchQueueData(data) {
  const url = `api/v1/export/quicksearch`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA_API}${url}`, data);
}

function post(postUrl, body) {
  return axios({
    method: 'post',
    url: postUrl,
    data: body,
  })
    .then(onSuccess)
    .catch(onError);
}

function postUnmatched(postUrl, body) {
  return axios({
    method: 'post',
    url: postUrl,
    data: body,
  })
    .then(onSuccess)
    .catch(onErrorUnmatched);
}

function put(postUrl, body) {
  return axios({
    method: 'put',
    url: postUrl,
    data: body,
  })
    .then(onSuccess)
    .catch(onError);
}
//For fetching multiple transaction by casenumber
export function fetchMultipleMatchTransactionByCaseNumber(caseNumber) {
  configureHttpHeaders(axios);
  return get(VITE_CASE_DATA2_API, `api/v1/disputecasedata/failedcase/${caseNumber}/transactions`);
}

export function uploadDocumentFiletype() {
  configureHttpHeaders(axios);
  return get(VITE_CASE_DATA_API, `api/v1/disputecasedata/document/type`);
}

export function getLiabilityDescription(url, searchInputDetails) {
  configureHttpHeaders(axios);
  return getDataWithPathVariable(url, searchInputDetails);
}
export function getAmexDisputeStages() {
  const url = 'api/v1/disputecasedata/amex/dispute/stages';
  configureHttpHeaders(axios);
  return getBase(`${CASE_DATA_API}${url}`);
}
export function getCaseStageLandingData(caseStageId) {
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, `api/v1/disputecasedata/op1case/${caseStageId}`);
}
export function fetchAccountDetails(caseNumber) {
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, `api/v1/disputecasedata/case/${caseNumber}/account`);
}
export function fetchAccountingDetails(caseNumber) {
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, `api/v1/disputecasedata/case/${caseNumber}/accounts`);
}
export function fetchTransactionDetails(caseNumber) {
  configureHttpHeaders(axios);
  return get(CASE_DATA2_API, `api/v1/disputecasedata/case/${caseNumber}/transaction`);
}

// Document Type for unmatched image queue
export function getDocumentTypeUrl(uiDocTypeListCode) {
  configureHttpHeaders(axios);
  return get(CASE_DATA_API, `api/v1/disputecasedata/document/typelist/${uiDocTypeListCode}`);
}

export function getQuestionnaireDetails(caseStageId) {
  configureHttpHeaders(axios);
  return get(CASE_DATA2_API, `api/v1/disputecasedata/questionnaire/case/${caseStageId}`);
}

export function getQuestionnaireAutoPopulateDetails(caseNumber) {
  configureHttpHeaders(axios);
  return get(CASE_DATA2_API, `api/v1/disputecasedata/questionnaire/credittransaction/${caseNumber}`);
}

export function getPrevFinancialsData(financialDataList, disputeStageId, caseNumber) {
  let payload = {
    ledgerInputList: financialDataList,
    disputeStageId: disputeStageId,
  };
  const Url = `api/v1/disputecasedata/previousFinancials?caseNumber=${caseNumber}`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA2_API}${Url}`, payload);
}

export function logWarningEvent(warningType, caseAdjustment, caseNumber) {
  let payload = {
    caseNumber: caseNumber,
    warnType: warningType,
    caseAdjustment: caseAdjustment,
  };
  const Url = `api/v1/disputecasedata/log/event`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA2_API}${Url}`, payload);
}

export function fetchTakeActionStatusOnMerchantUiSLAExpire(caseNumber) {
  const url = `api/v1/disputecasedata/takeaction/${caseNumber}/status`;
  return get(CASE_DATA2_API, url);
}

export function updateActiveStage(payload) {
  const Url = `api/v1/disputecasedata/multistage/toggle-active-stage`;
  configureHttpHeaders(axios);
  return post(`${CASE_DATA2_API}${Url}`, payload);
}

export function getCurrencyBasedOnElementIdWithAcquirer(elementId, acquirerAccessList) {
  configureHttpHeaders(axios);
  return elementId === 'cq_dispute_currency' || elementId === 'cq_trnsctn_currency' || elementId === 'cq_sttlmnt_crrncy'
    ? get(CASE_DATA_API, urlRelativeMapping[elementId] + `?acquirerAccessList=${acquirerAccessList}`)
    : null;
}

export function checkInstitutionName(caseNumber) {
  configureHttpHeaders(axios);
  return get(
    CASE_DATA2_API,
    `api/v1/disputecasedata/cases/${caseNumber}/institution-name/exists`
  );
}

function get(baseURL, url) {
  return axios.get(`${baseURL}${url}`).then(onSuccess).catch(onError);
}
function getBase(baseURL) {
  return axios.get(`${baseURL}`).then(onSuccess).catch(onError);
}
function deleteUrl(baseUrl, url) {
  return axios.delete(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}

export default {
  getAllUnmatchedCases,
  getFilterValuesBasedOnElementId,
  getFilterValuesBasedOnElementIdWithAcquirer,
  // getBaseQueueBasedOnAcquirer,
  getDataColumns,
  postActiveFilters,
  getRegionList,
  fetchMultipleMatchTransactionByCaseNumber,
  undoAttachTransaction,
  getTransferPurposeList,
  getTransferToList,
  transferCase,
  postLockCase,
  unlockCase,
  unlockAllCases,
  updateTimeForLockedCases,
  checkIfLocked,
  getLiabilityDescription,
  exportAmexQueueData,
  exportImageQueueData,
  exportQuickSearchQueueData,
  exportMerchantQueueData,
  exportDataSearchQueue,
  exportUnmatchedQueue,
  getDataColumnsCustomQueue,
  getQuestionnaireDetails,
  getPrevFinancialsData,
  exportActiveStageQueue,
  updateActiveStage,
  checkInstitutionName,
};
